export enum ValidationStatus {
  UNAVAILABLE = "UNAVAILABLE",
  PENDING = "PENDING",
  VALIDATED = "VALIDATED",
  REFUSED = "REFUSED",
}
